import {useLayoutEffect, useRef, useState} from 'react'
import ResizeObserver from 'resize-observer-polyfill'

type Value = number | undefined
type Ref = React.Ref<HTMLDivElement>

function useGeneralResizeObserver(field: 'offsetHeight' | 'offsetWidth'): [Value, Ref] {
  const [innerValue, setInnerValue] = useState<Value>()
  const ref = useRef<HTMLDivElement>(null)
  useLayoutEffect(() => {
    const element = ref.current
    if (element == null) {
      return undefined
    }
    const observer = new ResizeObserver(() => {
      setInnerValue(element[field])
    })
    observer.observe(element)
    return () => observer.disconnect()
  })

  return [innerValue, ref]
}

export function useHeightResizeObserver(): [Value, Ref] {
  return useGeneralResizeObserver('offsetHeight')
}

export function useWidthResizeObserver(): [Value, Ref] {
  return useGeneralResizeObserver('offsetWidth')
}
